import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export const store = new Vuex.Store({
  state: null,
  getters: {
    API_CLIENT_TARIFFS: state => {
      return '/captive_portal/client_tariffs'
    },
    API_REGISTER_CLIENT: state => {
      return '/captive_portal/register_client'
    },
    API_REGISTRY_SETTINGS_PHONE_FORMAT: state => {
      return '/phone_format'
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js